export default "__VITE_ASSET__CUbCBInR__"